import { Link } from 'react-router-dom';
import type { MediaItem } from '@/mocks/movies';
import { typeLabel } from '@/utils/media';

interface MediaCardProps {
  item: MediaItem;
}

export default function MediaCard({ item }: MediaCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-lg bg-background-50 border border-background-200 transition duration-300 hover:-translate-y-1 hover:border-accent-300 cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title}封面`}
          title={`${item.title} ${typeLabel(item.type)} 在线影视资料`}
          className="w-full h-full object-cover object-top transition duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 left-2 rounded-full bg-primary-950/75 px-2 py-0.5 text-[11px] font-medium text-background-50 backdrop-blur">
          {typeLabel(item.type)}
        </span>
        <span className="absolute top-2 right-2 flex items-center gap-0.5 rounded-full bg-accent-500 px-2 py-0.5 text-[11px] font-semibold text-accent-950">
          <i className="ri-star-fill text-[10px]"></i>
          {item.rating.toFixed(1)}
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-1 p-3">
        <h3 className="line-clamp-1 font-heading text-sm font-semibold text-foreground-950 group-hover:text-accent-600 transition">
          {item.title}
        </h3>
        <p className="line-clamp-1 text-xs text-foreground-500">{item.genres.join(' · ')}</p>
        <div className="mt-1 flex items-center justify-between text-xs text-foreground-500">
          <span>{item.year}</span>
          <span className="flex items-center gap-1">
            <i className="ri-map-pin-line"></i>
            {item.region}
          </span>
        </div>
      </div>
    </Link>
  );
}